export default class WsApiDriveService {
  path = "/ws/v1";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Détail d'un magasin
   * @param {Object} params
   */
  async simulationEcheancier(params) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/simulation-echeancier`, config);
    return res.data;
  }
}
